import { createFileRoute } from "@tanstack/react-router";
import MedicationsAfterTms from "@/pages/MedicationsAfterTms";
export const Route = createFileRoute("/medications-after-tms")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Medications After TMS | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Can you take antidepressants after TMS? Learn how medication and TMS work together for depression treatment in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "Medications After TMS | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Can you take antidepressants after TMS? Learn how medication and TMS work together for depression treatment in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/medications-after-tms",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/medications-after-tms",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <MedicationsAfterTms />;
}
